import { apiClient, getToken, getOrgId, getUserId } from '@devd-client/api';

export const getSprintList = (teamId?: string): Promise<any> =>
  apiClient(`/v1/org/${getOrgId()}/sprints${teamId ? `?team=${teamId}` : ''}`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const postFavSprint = (params: any) => {
  return apiClient(`/v1/user/${getUserId()}/preference/sprint`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(params),
  });
};

export const deleteFavSprint = (params: any) => {
  return apiClient(
    `/v1/user/${getUserId()}/preference/sprint/${params.sprint}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
    }
  );
};
